import { FormikTextField } from '@shared/components/inputs/FormikTextField';
import { FormikSelectField } from '@shared/components/inputs/FormikSelectField';
import type { SelectOption } from '@shared/components/inputs/SelectField/SelectField.types';
import { HEAR_ABOUT_OPTIONS } from '@constants/leadCaptureConstants';
import type { LeadCaptureSectionProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';

const mapNoneToNull = (option: SelectOption | null): SelectOption | null => (option?.value === 'none' ? null : option);

export const LeadSourceSection = ({ formik }: LeadCaptureSectionProps) => {
  const { values, setFieldValue } = formik;

  const handleLeadSourceChange = (value: string | number) => {
    if (value !== 'Other') {
      setFieldValue('otherLeadSource', '');
    }
  };

  return (
    <>
      <FormikSelectField
        formik={formik}
        name="howDidYouHear"
        label="How Did You Hear about Us?"
        optional
        placeholder="Select an Option"
        options={HEAR_ABOUT_OPTIONS}
        storeOption
        mapOption={mapNoneToNull}
        onValueChange={handleLeadSourceChange}
      />
      {values.howDidYouHear?.value === 'Other' ? (
        <FormikTextField
          formik={formik}
          name="otherLeadSource"
          label="Where Did You Hear about Us?"
          labelVariant="label.fieldMedium"
          multiline
          rows={8}
          className="lead-capture-multiline-input"
        />
      ) : null}
    </>
  );
};
